// Product gallery videos: play (muted, looping) while at least 60% visible, pause when
// swiped or scrolled away. Pausing keeps the position, so coming back resumes the video.
(function () {
  if (window.galleryVideoAutoplay) return;

  const SELECTOR = '.gallery-autoplay__video';
  const visible = new WeakMap();

  function isModalOpen() {
    return document.body.classList.contains('overflow-hidden');
  }

  function play(video) {
    if (isModalOpen() || document.hidden) return;
    video.muted = true;
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(() => {});
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const inView = entry.isIntersecting && entry.intersectionRatio >= 0.6;
        visible.set(entry.target, inView);
        if (inView) play(entry.target);
        else entry.target.pause();
      });
    },
    { threshold: [0, 0.6, 1] }
  );

  function setup(root) {
    (root || document).querySelectorAll(SELECTOR).forEach((video) => {
      if (video.dataset.autoplayReady) return;
      video.dataset.autoplayReady = 'true';
      video.muted = true;
      video.setAttribute('playsinline', '');
      observer.observe(video);

      // The theme pauses every video when the gallery changes slide or a modal opens.
      // If this video is still on screen afterwards, start it again.
      video.addEventListener('pause', () => {
        setTimeout(() => {
          if (video.paused && visible.get(video)) play(video);
        }, 200);
      });
    });
  }

  // Resume visible videos after the zoom modal closes or the tab becomes visible again.
  function resumeVisible() {
    document.querySelectorAll(SELECTOR).forEach((video) => {
      if (visible.get(video)) play(video);
    });
  }

  document.body.addEventListener('modalClosed', () => setTimeout(resumeVisible, 50));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) resumeVisible();
  });

  // Gallery markup can be swapped in (variant/product changes, theme editor).
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      setup();
    });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => setup(event.target));

  setup();
  window.galleryVideoAutoplay = { setup, resumeVisible };
})();
